import {
    HYBRID_ACTION_TYPES,
    HybridLaunchAppleManageSubscriptionViewAction,
    HybridLaunchAppleSubscriptionStoreAction,
} from '../../hybridMiddlewareConstants';

export const launchAppleSubscriptionStore = (): HybridLaunchAppleSubscriptionStoreAction => ({
    type: HYBRID_ACTION_TYPES.LAUNCH_APPLE_SUBSCRIPTION_STORE,
});

export const launchAppleManageSubscriptionView = (): HybridLaunchAppleManageSubscriptionViewAction => ({
    type: HYBRID_ACTION_TYPES.LAUNCH_APPLE_MANAGE_SUBSCRIPTION_VIEW,
});
